module.exports = __webpack_public_path__ + "img/retired-2009-museum.6753d9f5.jpg";